import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Alert, Button, InputAdornment, TextField, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import React, { useState } from 'react';
import useStyles from './styles';
import { useTranslation } from 'react-i18next';
export const ModalContent = _ref => {
  let propertyUtility = _ref.propertyUtility,
    defaultCadEnabled = _ref.defaultCadEnabled,
    handleModalClose = _ref.handleModalClose,
    onSaveHandler = _ref.onSaveHandler,
    goodWillDeductionValue = _ref.goodWillDeductionValue;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(propertyUtility.commonAreaDeduction || (defaultCadEnabled ? 5 : 0)),
    _useState2 = _slicedToArray(_useState, 2),
    CADValue = _useState2[0],
    setCADValue = _useState2[1];
  const _useState3 = useState((defaultCadEnabled ? CADValue !== 5 : CADValue !== 0) ? 'custom' : 'system'),
    _useState4 = _slicedToArray(_useState3, 2),
    CADType = _useState4[0],
    setCADType = _useState4[1];
  const customCadValidation = () => CADValue >= 0 && CADValue <= 100;
  const handleCADTypeChange = async (e, value) => {
    if (value) {
      setCADType(value);
      if (value === 'system') await setCADValue(defaultCadEnabled ? 5 : 0);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.form
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.formContent
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.cad')), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('add_new_property_flow.cad_hint'))), /*#__PURE__*/React.createElement("div", {
    className: classes.inlineToggleWrapper
  }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    value: CADType,
    onChange: handleCADTypeChange,
    exclusive: true
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "system"
  }, t('add_new_property_flow.use_system_deduction')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "custom"
  }, t('add_new_property_flow.override'))), CADType === 'custom' && /*#__PURE__*/React.createElement("div", {
    className: classes.sideInput
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('add_new_property_flow.custom_deduction'),
    variant: "outlined",
    value: CADValue,
    placeholder: "0",
    InputProps: {
      endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end"
      }, "%")
    },
    onKeyPress: event => {
      if (!/[0-9]|[.,]/.test(event.key)) {
        event.preventDefault();
      }
    },
    onChange: e => {
      if (!/^\d+([.,]\d{0,2})?$|^$/.test(e.target.value)) return;
      setCADValue(e.target.value);
    },
    error: !customCadValidation() || +CADValue + +goodWillDeductionValue > 100,
    helperText: !customCadValidation() && 'Max value is 100',
    fullWidth: true
  }))), (!customCadValidation() || +CADValue + +goodWillDeductionValue > 100) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Alert, {
    severity: "error",
    icon: false,
    size: "small"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, "The total of CAD and GWD cannot exceed 100%. We recommend the maximum allowable value for CAD is", ' ', 100 - goodWillDeductionValue, "%. Please adjust your input."))), +CADValue + +goodWillDeductionValue === 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Alert, {
    severity: "warning",
    icon: false,
    size: "small"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, "Both CAD and GWD cannot be zero.", /*#__PURE__*/React.createElement("br", null), "We recommend to assign a positive value to at least one of them."))), !(!customCadValidation() || +CADValue + +goodWillDeductionValue > 100) && /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.chip
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.current_deduction'), ": ", Number(CADValue).toFixed(2), "%")))), /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.rightButton
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    onClick: e => {
      e === null || e === void 0 || e.preventDefault();
      onSaveHandler(CADValue);
      handleModalClose();
    },
    disabled: !customCadValidation() || +CADValue + +goodWillDeductionValue > 100,
    'custom-attribute': '637-new-billing-module'
  }, t('add_new_property_flow.save_and_close')))));
};